// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {NormalShapeType} from './normal-shape-type.js'
import {Size} from './size.js'

export class NormalShape {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalShape {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsNormalShape(bb: flatbuffers.ByteBuffer, obj?: NormalShape): NormalShape {
    return (obj || new NormalShape()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsNormalShape(bb: flatbuffers.ByteBuffer, obj?: NormalShape): NormalShape {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new NormalShape()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  type(): NormalShapeType {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : NormalShapeType.Ellipse
  }

  size(obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Size()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startNormalShape(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addType(builder: flatbuffers.Builder, type: NormalShapeType) {
    builder.addFieldInt8(0, type, NormalShapeType.Ellipse)
  }

  static addSize(builder: flatbuffers.Builder, sizeOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, sizeOffset, 0)
  }

  static endNormalShape(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // size
    return offset
  }
}
